export default __webpack_public_path__ + "static/media/existing-recipe-icon.a1afa4cc.svg";